import { Apple, Smartphone } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import { walletPlatform } from '@/shared/lib/passbook-utils';
import { Badge } from '@/shared/ui/badge';

interface WalletPlatformBadgeProps {
  lead: {
    typeAccess?: string;
    deviceLibraryIdentifier?: unknown[];
    deviceToken?: Array<{ typeAccess?: string } | string>;
    deviceGWallet?: unknown[];
  };
  className?: string;
}

function platformStyle(platform: string): string {
  if (platform === 'iOS') {
    return 'border-transparent bg-orange-500/15 text-orange-600 dark:text-orange-400';
  }
  if (platform === 'Android' || platform === 'Google Wallet') {
    return 'border-transparent bg-blue-500/15 text-blue-600 dark:text-blue-400';
  }
  return '';
}

function PlatformIcon({ platform, className }: { platform: string; className?: string }) {
  if (platform === 'iOS') return <Apple className={className} />;
  if (platform === 'Android' || platform === 'Google Wallet') {
    return <Smartphone className={className} />;
  }
  return <Smartphone className={className} />;
}

export function WalletPlatformBadge({ lead, className }: WalletPlatformBadgeProps) {
  const platform = walletPlatform(lead);
  const isNone = platform === 'Nenhuma';

  return (
    <Badge
      variant={isNone ? 'secondary' : undefined}
      className={cn('gap-1 font-normal', !isNone && platformStyle(platform), className)}
    >
      <PlatformIcon platform={platform} className="size-3 shrink-0" />
      {platform}
    </Badge>
  );
}

interface InstallStatusBadgeProps {
  installed: boolean;
  className?: string;
}

export function InstallStatusBadge({ installed, className }: InstallStatusBadgeProps) {
  return (
    <Badge variant={installed ? 'success' : 'secondary'} className={cn('font-normal', className)}>
      {installed ? 'Instalado' : 'Não instalado'}
    </Badge>
  );
}
